import { Navigate, Route, Routes } from 'react-router-dom';
import { LoginPage } from './pages/auth/LoginPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { RegisterPage } from './pages/account/RegisterPage';
import { UsersPage } from './pages/account/UsersPage';
import { ManageAccountPage } from './pages/account/ManageAccountPage';
import { ChangePasswordPage } from './pages/account/ChangePasswordPage';
import { ChangeEmailPage } from './pages/account/ChangeEmailPage';
import { SitesListPage } from './pages/sites/SitesListPage';
import { SiteDetailPage } from './pages/sites/SiteDetailPage';
import { SiteGeometryDevicesPage } from './pages/sites/SiteGeometryDevicesPage';
import { FieldNotesPage } from './pages/sites/FieldNotesPage';
import { BrowsePage } from './pages/data/BrowsePage';
import { ExportPage } from './pages/data/export/ExportPage';
import { FarmerDataPage } from './pages/data/FarmerDataPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { RequireAuth, RequirePermission, AuthPolicy } from './lib/auth';
import { MainLayout } from './components/layout/MainLayout';

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      
      {/* Legacy routes from backend email links (Razor Pages format) */}
      <Route path="/Account/Login" element={<LoginPage />} />
      <Route path="/Account/ResetPassword" element={<ResetPasswordPage />} />
      
      {/* Error routes */}
      <Route path="/unauthorized" element={<AccessDeniedPage />} />
      <Route path="/access-denied" element={<AccessDeniedPage />} />
      
      {/* Protected routes */}
      <Route element={<RequireAuth />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          
          {/* Sites Management */}
          <Route path="/sites" element={<SitesListPage />} />
          <Route path="/sites/:siteId" element={<SiteDetailPage />}>
            <Route index element={<Navigate to="geometry" replace />} />
            <Route path="geometry" element={<SiteGeometryDevicesPage />} />
            <Route path="notes" element={<FieldNotesPage />} />
          </Route>
          
          {/* Data Management */}
          <Route path="/data/browse" element={<BrowsePage />} />
          <Route path="/data/export" element={<ExportPage />} />
          <Route path="/data/farmer-data" element={<FarmerDataPage />} />
          
          {/* Account Management */}
          <Route path="/account/manage" element={<ManageAccountPage />} />
          <Route path="/account/change-password" element={<ChangePasswordPage />} />
          <Route path="/account/change-email" element={<ChangeEmailPage />} />
          
          {/* User Management - requires UserManager policy */}
          <Route element={<RequirePermission policy={AuthPolicy.UserManager} />}>
            <Route path="/account/register" element={<RegisterPage />} />
            <Route path="/account/users" element={<UsersPage />} />
          </Route>
        </Route>
      </Route>
      
      {/* 404 - Must be last */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
